import React from "react";

/** Scrollable message list inside the AI chat panel, including the typing dots. */
export default function ChatBody({ messages, busy, scrollerRef }) {
  return (
    <div ref={scrollerRef} className="md-ai-body no-scrollbar" data-testid="ai-chat-body">
      {messages.map((m, i) => (
        <div
          key={`${i}-${m.role}-${(m.content || "").slice(0, 24)}`}
          className={`md-ai-row md-ai-row-${m.role}`}
          data-testid={`ai-chat-msg-${m.role}-${i}`}
        >
          <div className="md-ai-bubble">
            {m.content.split("\n").map((line, k) => (
              <p key={`${i}-line-${k}-${line.slice(0, 12)}`} style={{ margin: 0 }}>{line}</p>
            ))}
          </div>
        </div>
      ))}
      {busy && (
        <div className="md-ai-row md-ai-row-assistant" data-testid="ai-chat-typing">
          <div className="md-ai-bubble md-ai-typing"><span></span><span></span><span></span></div>
        </div>
      )}
    </div>
  );
}
